import { color } from "@codemirror/theme-one-dark";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_BLOCK_PREFIX, BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_QUIZ(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.MESSAGES, name: name, contents: [] };
  cat.contents = [
    BH.label("Quiz Blöcke"),
    BH.withNested(
      BH.quiz("QUIZ_START_FROM_TEXT", `Quiz (Single Choice)\n anhand eines Dokuments Starten {{source}}
      Anzahl Fragen {{qNumber}} Anzahl Falsche Antworten {{wrongAnswers}}\nNächste Frage: {{autoQuestions:dropdown=automatisch stellen|true, manuell auslösen|false}}
      ⚙️ Weiter Konfiguration:

      🏃 Bei Start:{{?start:statement[@check=ACTION]}}
      ✅ Wenn Richtig 🔻:{{?right:statement[@check=ACTION]}}
      ❌ Wenn Falsch 🔻:{{?wrong:statement[@check=ACTION]}}
      Ende:{{?end:statement[@check=ACTION]}}
      🏷️ Optionaler Identifikator – für Verlauf-Filterung/Reset:{{?skillId:text=MeinSCQuiz1}}
      `
        ,
        `
   RAGAI.EVENTS.on("RAGAI.QUIZ.INIT",  function(name, uuid) {
   RAGAI.QUIZ.CONF_QUESTIONS_COUNT = {{qNumber}};
   RAGAI.QUIZ.CONF_WRONG_ANSWER_COUNT = {{wrongAnswers}};
   RAGAI.QUIZ.QUIZ_SOURCE_SKILL_ID = {{skillId}};


    console.log("Quiz mit UUID gestartet: " + uuid);
    RAGAI.EVENTS.on("RAGAI.QUIZ.START", async function(eventName, eventData)  {
      //USERS ON START
       {{start}}
   if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   }, uuid +"-start");
  RAGAI.EVENTS.on("RAGAI.QUIZ.RIGHTANSWER", async (eventName, eventData) => {
    //USERS ON RIGHT ANSWER
     {{right}}
    if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   },uuid +"-right");
   RAGAI.EVENTS.on("RAGAI.QUIZ.WRONGANSWER", async (eventName, eventData) => {
    //USERS ON WRONG ANSWER
    {{wrong}}
     if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   },uuid +"-wrong");
   RAGAI.EVENTS.on("RAGAI.QUIZ.END", async (eventName, eventData) => {
      //USERS ON END
     {{end}}
     //GENERAL ON END
     RAGAI.QUIZ.cleanupQuiz(uuid);
   },uuid +"-end");
},"RAGAI_QUIZ_INIT");
  // DAS QUIZ STARTEN
   await RAGAI.QUIZ.startFromText({{source}});


   `), [
      { forValue: "qNumber", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 3 } },
      { forValue: "wrongAnswers", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 3 } },
      { forValue: "source", isShadow: true, targetBlockType: 'BLOCK_STACK_DOCUMENT_CONTENT' },
      { forValue: "start", isShadow: false, targetBlockType: 'AVATAR_CHAT_FOOTER', targetBlockDefaults: { option: 'hide' } },
      { forValue: "right", isShadow: false, targetBlockType: 'CONFETTI' },
      /* { forValue: "wrong", isShadow: false, targetBlockType: 'QUIZ_NEXT_QUESTION' }, */
      { forValue: "end", isShadow: false, targetBlockType: 'AVATAR_CHAT_FOOTER' }
    ]),
    BH.withNested(
      BH.quiz("QUIZ_START_FROM_TEXT_FREETEXT", `Quiz (Freitext-Antwort)\n anhand eines Dokuments Starten {{source}}
      Anzahl Fragen {{qNumber}}\nNächste Frage: {{autoQuestions:dropdown=automatisch stellen|true, manuell auslösen|false}}
      ⚙️ Weiter Konfiguration:
      🏃 Bei Start:{{?start:statement[@check=ACTION]}}
      ✅ Wenn Richtig 🔻:{{?right:statement[@check=ACTION]}}
      ❌ Wenn Falsch 🔻:{{?wrong:statement[@check=ACTION]}}
      Ende:{{?end:statement[@check=ACTION]}}
      🏷️ Optionaler Identifikator – für Verlauf-Filterung/Reset:{{?skillId:text=MeinFreitextQuiz1}}`
        ,
        `
   RAGAI.EVENTS.on("RAGAI.QUIZ.INIT",  function(name, uuid) {
   RAGAI.QUIZ.CONF_QUESTIONS_COUNT = {{qNumber}};
   RAGAI.QUIZ.CONF_WRONG_ANSWER_COUNT = 0;
   RAGAI.QUIZ.QUIZ_SOURCE_SKILL_ID = {{skillId}};
   RAGAI.QUIZ.ANSWER_MODE = "freetext";
   RAGAI.BEFORE_SEND.add(async function(message){ return await RAGAI.QUIZ.handleFreetextAnswer(message); });

    console.log("Freitext-Quiz mit UUID gestartet: " + uuid);
    RAGAI.EVENTS.on("RAGAI.QUIZ.START", async function(eventName, eventData)  {
      //USERS ON START
       {{start}}
   if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   }, uuid +"-start");
  RAGAI.EVENTS.on("RAGAI.QUIZ.RIGHTANSWER", async (eventName, eventData) => {
    //USERS ON RIGHT ANSWER
     {{right}}
    if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   },uuid +"-right");
   RAGAI.EVENTS.on("RAGAI.QUIZ.WRONGANSWER", async (eventName, eventData) => {
    //USERS ON WRONG ANSWER
    {{wrong}}
     if({{autoQuestions}}) { await RAGAI.QUIZ.nextQuestion(); }
   },uuid +"-wrong");
   RAGAI.EVENTS.on("RAGAI.QUIZ.END", async (eventName, eventData) => {
      //USERS ON END
     {{end}}
     //GENERAL ON END
     RAGAI.QUIZ.cleanupQuiz(uuid);
   },uuid +"-end");
},"RAGAI_QUIZ_INIT");
  // DAS QUIZ STARTEN
   await RAGAI.QUIZ.startFromText({{source}});


   `), [
      { forValue: "qNumber", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 3 } },
      { forValue: "source", isShadow: true, targetBlockType: 'BLOCK_STACK_DOCUMENT_CONTENT' },
      { forValue: "right", isShadow: false, targetBlockType: 'CONFETTI' },
      { forValue: "end", isShadow: false, targetBlockType: 'AVATAR_CHAT_FOOTER' }
    ]),
    BH.actionDropdown("QUIZ_ACTIONS",
      "Quiz Aktionen", [
      [
        "Nächste Frage auslösen", "await RAGAI.QUIZ.nextQuestion();"
      ],
      [
        "Beenden", "await RAGAI.QUIZ.endQuiz();"
      ]
    ]),

    BH._custom("QUIZ_ANSWER_DATA", "@output:String\n 🔻 Aktuellen Nutzer-Antwort:\n {{key:dropdown=🔡 Gewählte Antwort|answered,🔡 Aktuelle Frage|question,⎇ War richtig?|right,🔡 Die richtige Lösung|solution,🔡 KI-Begründung (nur Freitext-Modus)|reasoning}}", "eventData.{{key}}", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
    //    BH._custom("QUIZ_GENERA_DATA", "@output:String\n Quiz Info Daten: {{key:dropdown=Aktuelle Antwort|answered,Gestellte Frage|question,War richtig|right,Aktuelle Lösung|solution}}", "RAGAI.QUIZ.{{key}}", { colour: BLOCKLY_COLORS.EVENTS_LIGHT })

    BH.propertyDropdown("QUIZ_GENERA_DATA", "ℹ️ Quiz Info:\n ", [
      ["🔢 Bisher richtige Antworten", "RAGAI.QUIZ.RIGHT_ANSWERS"],
      ["🔢 Bisher falsche Antworten", "RAGAI.QUIZ.WRONG_ANSWERS"],
      ["🔢 Fragen anzahl Insgesammt", "RAGAI.QUIZ.CONF_QUESTIONS_COUNT"],
      ["⎇ Quiz aktiv?", "RAGAI.QUIZ.IS_RUNNING"],
      ["🔢 Noch Offene Fragen", "RAGAI.QUIZ.QUESTIONS_UPCOMMING"],
      ["🔢 Bisher gestellte Fragen", "RAGAI.QUIZ.ASKED_QUESTIONS"],
      ["🔢 Bisher beantwortete", "RAGAI.QUIZ.ANSWERED_QUESTIONS"],
      ["🔢 Index (Zähler) der nächsten Frage", "RAGAI.QUIZ.CURRENT_QUESTION_NUMBER"]
    ]),

    BH.withNested(
      BH._custom("QUIZ_ADDITIONAL_PROMPT_INFO", "Zusätzliche Anweisung zur Frage-Extraktion: {{p}}", "RAGAI.QUIZ.ADDITIONAL_PROMPT_INFO={{p}};", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
      [
        { forValue: "p", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "" } }
      ]
    ),
    BH.label("Quiz-Verlauf (projektweit, botuebergreifend)"),
    BH._custom("QUIZ_HISTORY_ENABLED", "🕘 Quiz-Verlauf protokollieren & in Prompt einbeziehen: {{enabled:dropdown=ja|true, nein|false}}", "RAGAI.QUIZ.QUIZ_USE_HISTORY = {{enabled}};", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
    BH.withNested(
      BH._custom("QUIZ_HISTORY_LIMIT_SET", "🕘 Anzahl Verlaufseinträge im Prompt (0 = alle): {{n}}", "RAGAI.QUIZ.QUIZ_HISTORY_LIMIT = {{n}};", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
      [
        { forValue: "n", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 20 } }
      ]
    ),
    BH._custom("QUIZ_HISTORY_CLEAR", "🔻 Quiz-Verlauf dieses Nutzers löschen", "await RAGAI.QUIZ.clearHistory();", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
    BH._custom("QUIZ_DEBUG_ALL", "🔻 Quiz Debug Alle Daten ausgeben", "await RAGAI.QUIZ.debug(eventData);", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),

    //    BH.quiz("QUIZ_NEXT_QUESTION", `QUIZ Aktion: {aktion=Dropdown}`, `{{aktion}}`)




  ];
  return cat;
}
